require('./lbaPointsOfInterestList.scss');

const lbaPointsOfInterestList = angular.module('app.lbaPointsOfInterestList', [
  require('../lbaPointsOfInterestListItem/lbaPointsOfInterestListItem').name
]);

lbaPointsOfInterestList.component('lbaPointsOfInterestList', {
  bindings: {
    pointsOfInterest: '=',
    newItem: '=',
    editItem: '=',
    activateItem: '='
  },
  controller: lbaPointsOfInterestListCtrl,
  template: `
    <div class="lbaPointsOfInterest_list_container">
      <h3 class="lbaPointsOfInterest_heading">
        Locations
      </h3>

      <div class="lbaPointsOfInterest_addNew">
        <button ng-click="$ctrl.newItem()" class="btn btn-primary"><span class="fa fa-plus"></span>New</button>
      </div>

      <div class="lbaPointsOfInterest_filter" ng-show="$ctrl.pointsOfInterest.length > 1">
        <input type="text" ng-model="$ctrl.pointsOfInterestFilter" class="lbaPointsOfInterest_filter_input form-control" placeholder="Filter locations">
      </div>
      <div class="lbaPointsOfInterest_scroller">
        <ul class="lbaPointsOfInterest_list list-group">
          <li ng-repeat="pointOfInterest in $ctrl.pointsOfInterest | filter : {Title : $ctrl.pointsOfInterestFilter}" class="lbaPointsOfInterest_listItem_container list-group-item" ng-class="{'active': pointOfInterest.active}">
            <lba-point-of-interest-list-item
               activate-item="$ctrl.activateItem"
               point-of-interest="pointOfInterest"
               edit-item="$ctrl.editItem">
            </lba-point-of-interest-list-item>
          </li>
        </ul>
      </div>
    </div>
  `
});

function lbaPointsOfInterestListCtrl() {
  let $ctrl = this;

}

export default lbaPointsOfInterestList;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterestList/lbaPointsOfInterestList.js